export const baseUrl = 'https://trmsdr.com'
export const baseReportUrl = 'https://trmsdr.com'
